import React from 'react'
import {
  TableHead,
  TableRow,
  TableData
} from '../table'
import SortableHeader from '../table/sortable_header'
import {
  TableCellWidth,
  PriceFieldNameByMarkupAndCurrency,
  PerCaratFieldNameByMarkupAndCurrency,
  RapDiscountFieldNameByMarkup
} from '../../utils/diamond-search-result'

const SearchResultTableHeader = props => {
  return (
    <TableHead>
      <TableRow>
        <TableData width={TableCellWidth.checkbox} />
        <TableData width={TableCellWidth.stockNumber}>
          <SortableHeader
            title='Stock Number'
            fieldName='Stock Number' />
        </TableData>
        {
          props.matchedSets &&
            <TableData width={TableCellWidth.pairSort}>
              <SortableHeader
                title='Pair ID'
                fieldName='Pair Sort ID Hash' />
            </TableData>
        }
        <TableData width={TableCellWidth.seller}>
          <SortableHeader
            title='Seller'
            fieldName='Name Code' />
        </TableData>
        <TableData width={TableCellWidth.shape}>
          <SortableHeader
            title='Shape'
            fieldName='Shape' />
        </TableData>
        <TableData width={TableCellWidth.carat}>
          <SortableHeader
            title='Carat'
            fieldName='Weight' />
        </TableData>
        <TableData width={TableCellWidth.colour}>
          <SortableHeader
            title='Colour'
            fieldName={props.colourType === 'regular' ? 'Color' : 'Fancy Color'} />
        </TableData>
        <TableData width={TableCellWidth.clarity}>
          <SortableHeader
            title='Clarity'
            fieldName='Clarity' />
        </TableData>
        <TableData width={TableCellWidth.cut}>
          <SortableHeader
            title='Cut'
            fieldName='Cut' />
        </TableData>
        <TableData width={TableCellWidth.polish}>
          <SortableHeader
            title='Polish'
            fieldName='Polish' />
        </TableData>
        <TableData width={TableCellWidth.symmetry}>
          <SortableHeader
            title='Symm'
            fieldName='Symmetry' />
        </TableData>
        <TableData width={TableCellWidth.fluorescence}>
          <SortableHeader
            title='Fluor'
            fieldName='Fluorescence Intensity' />
        </TableData>
        <TableData width={TableCellWidth.perCaratPrice}>
          <SortableHeader
            title='Per Ct'
            fieldName={PerCaratFieldNameByMarkupAndCurrency(props.markupType, props.currency)} />
        </TableData>
        <TableData width={TableCellWidth.rapDiscount}>
          <SortableHeader
            title='Rap'
            fieldName={RapDiscountFieldNameByMarkup(props.markupType)} />
        </TableData>
        <TableData width={TableCellWidth.price}>
          <SortableHeader
            title='Price'
            fieldName={PriceFieldNameByMarkupAndCurrency(props.markupType, props.currency)} />
        </TableData>
        <TableData width={TableCellWidth.lab}>
          <SortableHeader
            title='Lab'
            fieldName='Lab' />
        </TableData>
        <TableData width={TableCellWidth.photo}>
          <SortableHeader
            title='Photo'
            fieldName='Image URL' />
        </TableData>
        <TableData width={TableCellWidth.depth}>
          <SortableHeader
            title='Depth'
            fieldName='Depth' />
        </TableData>
        <TableData width={TableCellWidth.table}>
          <SortableHeader
            title='Table'
            fieldName='Table' />
        </TableData>
        <TableData width={TableCellWidth.measurements}>
          <SortableHeader
            title='Measurements'
            fieldName='Meas Length' />
        </TableData>
      </TableRow>
    </TableHead>
  )
}

export default SearchResultTableHeader



// WEBPACK FOOTER //
// ./src/components/search-results/search-result-table-header.js